import { Box, Typography } from "@mui/material";
import { REPORT_COMPANY } from "modules/came/shared/reportCompany";
export default function ReportCompanyHeader() {
  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, borderBottom: "1px solid", borderColor: "divider" }}>
      <Typography variant="subtitle2" fontWeight={700}>
        {REPORT_COMPANY.nombre}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {REPORT_COMPANY.servicio} · {REPORT_COMPANY.version}
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", columnGap: 3, rowGap: 0.5, mt: 1 }}>
        <Typography variant="body2">
          <strong>Licenciado a:</strong> {REPORT_COMPANY.razonSocial}
        </Typography>
        <Typography variant="body2">
          <strong>NIT:</strong> {REPORT_COMPANY.nit}
        </Typography>
        <Typography variant="body2">
          <strong>ID máquina:</strong> {REPORT_COMPANY.idMaquina}
        </Typography>
      </Box>
    </Box>
  );
}
